/**
 * 来自开放平添的页面访问
 * 1、本地文件上传：http://mdev.fangcloud.net:8081/open_upload?accessToken=60343a4f-06d1-44c4-9843-36d1a5dec563&folderId=0
 * 2、本地文件上传：http://mdev.fangcloud.net:8081/open_upload?accessToken=60343a4f-06d1-44c4-9843-36d1a5dec563&targetFolderPath=会议/2019
 * 3、本地文件上传：http://mdev.fangcloud.net:8081/open_upload?folderId=0
 * uploadFileMax 为 optional 参数，default：1
 */

import config from '../config'
// import load from '@/utils/fangcloud-loader'

export default class OpenBootstrap {
  static isFromOpenPlatform () {
    // 目前只有开放平台过来预览的且通过token形式访问的情况才进入单独的openBootstrap
    let pathNameArr = location.pathname.split('/').filter(item => item)
    let accessTokenMatch = window.location.search.match(new RegExp(`accessToken=([^&]+)`))
    if ((pathNameArr.includes('open_preview') || pathNameArr.includes('open_upload')) && accessTokenMatch) {
      return true
    }
    return false
  }

  constructor () {
    let accessTokenMatch = window.location.search.match(new RegExp(`accessToken=([^&]+)`))
    let folderIdMatch = window.location.search.match(new RegExp(`folderId=([^&]+)`))
    let targetFolderPathMatch = window.location.search.match(new RegExp(`targetFolderPath=([^&]+)`))
    if (accessTokenMatch) {
      this.token = decodeURIComponent(accessTokenMatch[1])
    }
    if (folderIdMatch) {
      this.folderId = decodeURIComponent(folderIdMatch[1])
    }
    if (targetFolderPathMatch) {
      this.targetFolderPath = decodeURIComponent(targetFolderPathMatch[1])
    }
  }

  // loadJs () {
  //   load.js('//res.wx.qq.com/open/js/jweixin-1.4.0.js').then(_ => {})
  // }

  bootstrap () {
    config.isOpenPlatformWithToken = true
    config.openConfig.accessToken = this.token
    config.openConfig.uploadDestFolderId = this.folderId || 0
    config.openConfig.uploadDestFolderPath = this.targetFolderPath
    return Promise.resolve()
  }
}
